function Faq() {
    this.element = $('.js-faq');
    this.items = null;
    this.topics = null;

    // Initial setup of FAQ sections
    $('article').hide();
    $('article').first().show();
    $('.js-faq--topic').first().addClass('active');
    $('.js-accessibility').hide();

    // Elements for items and topics
    this.topics = this.element.find('.js-faq--topics a');
    this.items = this.element.find('.js-item');

    // Initialize FaqItems and FaqTopics
    var _this = this;
    this.items.each(function (index, item) {
        var items = $(item);
        new FaqItems(items);
    });

    this.topics.each(function (index, item) {
        var topic = $(item);
        new FaqTopics(topic);
    });

    // Show the first item in the active topic
    $('#' + $('.js-faq--topic.active').attr('aria-controls')).find('.js-item').first().addClass('active');

    // Initialize the search functionality
    this.initSearch();
}

Faq.prototype.initSearch = function () {
    var _this = this;
    // Reference to the search field
    var searchField = this.element.find('.js-zoekveld');

    // Attach an event listener to the search input for real-time filtering
    searchField.on('input', function () {
        var filterValue = searchField.val().toLowerCase().trim();
        var keywords = filterValue.split(/\s+/); // Split by whitespace to handle multiple keywords

        // Remove active class from the current active topic
        $('.js-faq--topic.active').removeClass('active');

        if (filterValue === "") {
            // If the search field is empty, reset to the default topic view
            $('article').hide();
            $('article').first().show();
            $('.js-faq--topic').first().addClass('active'); // Set the first topic as active
            _this.items.show(); // Show all items
        } else {
            // Temporarily show all articles to allow items from all topics to be considered
            $('article').show();

            // Filter items based on the search keywords
            _this.items.each(function (index, item) {
                var itemText = $(item).text().toLowerCase(); // itemText is a string

                // Check if all keywords are present in the item's text
                var isMatch = true;
                for (var i = 0; i < keywords.length; i++) {
                    if (itemText.indexOf(keywords[i]) === -1) {
                        isMatch = false;
                        break;
                    }
                }

                // Show or hide item based on match result
                $(item).toggle(isMatch);
            });
        }
    });
};


function FaqTopics(topic) {
    this.element = topic;
    var _this = this;
    this.element.on('click', function (event) {
        _this.open(event);
    });
}

FaqTopics.prototype.open = function (event) {
    event.preventDefault();
    var tab = '#' + this.element.attr('aria-controls');
    $('article').hide();
    $(tab).show();
    if (this.element.hasClass('active')) {
        this.element.removeClass('active');
    } else {
        $('.js-faq--topic.active').removeClass('active');
        this.element.addClass('active');
    }
};

function FaqItems(items) {
    this.element = items;
    this.content = this.element.find('dd');
    var _this = this;
    this.element.on('mouseup', function () {
        _this.toggle();
    });
    this.element.removeClass('active');
}

FaqItems.prototype.toggle = function () {
    if (this.element.hasClass('active')) {
        this.element.removeClass('active');
    } else {
        $('.js-item.active').removeClass('active');
        this.element.addClass('active');
    }
};

var faq = new Faq();
